import "../Styles/index.scss";

import AOS from "aos";
AOS.init();

import Flickity from "flickity";
import "flickity-imagesloaded";

let sliders = new Map<HTMLElement, Flickity>();
for (let element of document.querySelectorAll<HTMLElement>(".flickity")) {
	let slider = new Flickity(element, {
		pageDots: false,
		imagesLoaded: true,
	});
	sliders.set(element, slider);
}

import { Fancybox } from "@fancyapps/ui";
const domParser = new DOMParser();
Fancybox.bind(".is-zoomable", {
	groupAttr: "data-gallery",
	Carousel: {
		formatCaption: (carouselRef, slide) => {
			return domParser.parseFromString(slide.caption ?? "", "text/html").documentElement.textContent ?? "";
		},
	},
});
Fancybox.bind("[data-fancybox]", {
	on: {
		ready: (fancybox) => {
			const container = fancybox.getContainer();
			for (let element of container.querySelectorAll<HTMLElement>(".flickity")) {
				let slider = sliders.get(element);
				slider?.resize();
			}
		}
	}
});

import { initializeMaps } from "@wagich/bluc-map";
initializeMaps();

for (let element of document.querySelectorAll<HTMLElement>(".navigation__toggle")) {
	element.addEventListener("click", () => {
		const overlay = document.querySelector<HTMLElement>(".navigation__overlay");
		overlay?.classList.toggle('is-active');
	});
}
